exports = module.exports = require("/Volumes/Work/ITCase/baikal430/node_modules/css-loader/cssToString.js")();
exports.push([module.id, ".WaveLink{background-image:url("+require("./underline.png")+");background-size:30px 4px;background-position:bottom;background-repeat:repeat-x}", ""]);


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader/lib!./~/stylus-loader!./src/components/WaveLink/WaveLink.styl
// module id = 224
// module chunks = 0